import { gql } from '@apollo/client'
import { ContractSignature, ContractTemplate } from './types'

export const SIGN_CONTRACT = gql`
  mutation SignContract(
    $creatorId: Int!
    $contractTemplateId: Int!
    $input: SignContractInput!
  ) {
    signContract(
      creatorId: $creatorId
      contractTemplateId: $contractTemplateId
      input: $input
    ) {
      id
      signedAt
      ipAddress
      legalTrackingData
      creator {
        id
        firstName
        lastName
        email
      }
      contractTemplate {
        id
        type
        version
        text
        link
        status
        isActive
        activatedAt
      }
    }
  }
`

export const CHECK_CONTRACT_STATUS = gql`
  query CheckCreatorContractStatus($creatorId: Int!) {
    checkCreatorContractStatus(creatorId: $creatorId) {
      hasSignedActiveContract
    }
  }
`

export const GET_ACTIVE_CONTRACT_TEMPLATE = gql`
  query GetActiveCreatorContractTemplate {
    getActiveCreatorContractTemplate {
      id
      type
      version
      text
      link
      status
      isActive
      activatedAt
    }
  }
`

export interface SignContractResponse {
  signContract: ContractSignature
}

export interface CheckContractStatusResponse {
  checkCreatorContractStatus: {
    hasSignedActiveContract: boolean
  }
}

export interface GetActiveContractTemplateResponse {
  getActiveCreatorContractTemplate: ContractTemplate
}
